module.exports = __webpack_public_path__ + "img/gbwhatsapp-download.3c769aa8.webp";